<template>
    <div class="loading">
      <div class="loader-bottom">{{message}}</div>
        <div class="loader-top">
            <span class="loader"></span>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
    .loading{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin:1rem 0rem;
        background:transparent!important;
    }

    .loader-bottom{
        color:var(--loading-color);
        white-space: nowrap;
    }

  .loader {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
  margin:15px auto;
  position: relative;
  color: #FFF;
  left: -100px;
  box-sizing: border-box;
  animation: shadowRolling 2s linear infinite;
}

@keyframes shadowRolling {
  0% {
    box-shadow: 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);
  }
  12% {
    box-shadow: 100px 0  var(--loading-color), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);
  }
  25% {
    box-shadow: 110px 0  var(--loading-color), 100px 0  var(--loading-color), 0px 0 rgba(255, 255, 255, 0), 0px 0 rgba(255, 255, 255, 0);
  }
  36% {
    box-shadow: 120px 0  var(--loading-color), 110px 0  var(--loading-color), 100px 0  var(--loading-color), 0px 0 rgba(255, 255, 255, 0);
  }
  50% {
    box-shadow: 130px 0  var(--loading-color), 120px 0  var(--loading-color), 110px 0  var(--loading-color), 100px 0  var(--loading-color);
  }
  62% {
    box-shadow: 200px 0 rgba(255, 255, 255, 0), 130px 0  var(--loading-color), 120px 0  var(--loading-color), 110px 0  var(--loading-color);
  }
  75% {
    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 130px 0  var(--loading-color), 120px 0  var(--loading-color);
  }
  87% {
    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 130px 0  var(--loading-color);
  }
  100% {
    box-shadow: 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0), 200px 0 rgba(255, 255, 255, 0);
  }
}

@media(max-width: 768px){
   /* .loader-bottom{
        font-size:0.9rem;
    } */
}
</style>